import gql from 'graphql-tag';

export const getApprovalNotifications = gql`
    query getApprovalNotifications {
        getApprovalNotifications {
            posts
            boosts
        }
    }
`